/**
 * 短信回复模拟数据
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取客户回复短信 get  接口地址 /api/v1/get_receive_sms/{sms_id} 需要权限 企业号登陆
Mock.mock(/get_receive_sms\/\d+/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'mobile_number': '15914039385',
    'content': 'gagerge热供热个更热狗热供热热干面热加工热健康感慨感慨扔呢欧冠个而供热哦和个够IE偶家机构二十几个破耳机评估金额破股票而普工Joe及更改 ，二极管和加热哦个软件公司几个破色谱管培生热个人更贫困破开工卡破看过破刃。',
    'customer_name': '李白'
  },
  'message': 'ok'
})

// 发送短信 post  接口地址 /api/v1/send_sms/{sms_id}   这里的id是指客户回复的sms的id 需要权限 企业号登陆
Mock.mock(/send_sms\/\d+/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok'
})
